import { MESSAGING_CLIENT_ELEMENT_ID } from '../constants/index';
import Service, { service } from '@ember/service';

export const EVENT_NAMES = {
  openClientProfile: 'openClientProfile',
};

export default class MessagingEventsService extends Service {
  @service('spds/toast') toast;
  @service intl;

  emit(eventName, data) {
    const messagingClient = document.getElementById(MESSAGING_CLIENT_ELEMENT_ID);
    if (!messagingClient) {
      return this.toast.error(this.intl.t('emc.general_error'));
    }
    const event = new CustomEvent('messagingEvent', { detail: { name: eventName, data } });
    messagingClient.dispatchEvent(event);
  }
}
